<template>
  <div>
    <div id="app">
    <supportformmodal v-if="pageName !='categorizer'
    && pageName !='segregator' 
    && pageName !='summarypage'
       && pageName !='customerregistration'
        && pageName !='forensicsdashboard'
        && pageName != 'partnerforensics'
        && pageName != 'partnerapproval'
        && pageName != 'partnerqueries'
        && pageName != 'gstmanagement'
        && pageName !='vendordetails'
        && pageName !='workbench'
        && pageName !='reports' 
        && pageName !='login' 
        && pageName !='home' 
        && pageName !='registerpage'
        && pageName !='resetpassword'
        && pageName !='changepasswordpage'
        && pageName.toLowerCase() !='grievanceinternational'" ></supportformmodal>   
            <!--(pageName='dashboardpage' || pageName=='onboardingdetails')"--> 
      <helpLinks :variant="'outline-none'"
      style="margin-right: 0px;margin-top:0px;" v-if="pageName !='onboardingdetails' 
      && pageName !='workbench' 
      && pageName.toLowerCase() !='categorizer'
       && pageName.toLowerCase() !='customerregistration'
        && pageName.toLowerCase() !='forensicsdashboard'
        && pageName.toLowerCase() !='vendordetails'
        && pageName.toLowerCase() !='workbench'
        && pageName.toLowerCase() !='reports' 
        && pageName.toLowerCase() !='partnerqueries'
        && pageName.toLowerCase() !='grievanceinternational'" ></helpLinks>
      <appChat v-if="pageName !='onboardingdetails' && pageName !='workbench' 
      && pageName.toLowerCase() !='categorizer'
       && pageName.toLowerCase() !='customerregistration'
        && pageName.toLowerCase() !='forensicsdashboard'
        && pageName.toLowerCase() !='vendordetails'
        && pageName.toLowerCase() !='workbench'
        && pageName.toLowerCase() !='reports' 
        && pageName.toLowerCase() !='partnerqueries'
        && pageName.toLowerCase() !='grievanceinternational'" />
      <component :is="layout">
        <router-view />
      </component>
    </div>
  </div>
</template>

<script>
//console.log = function() {};
import "vue-multi-select/dist/lib/vue-multi-select.css";
import "vueperslides/dist/vueperslides.css";

// import "vue-multi-select/dist/lib/vue-multi-select.min.css";
// import Chart from "chart.js";
import ChatVue from "./components/homepage/Chat";
import { DashboardService } from "../src/services/DashboardService";
import { types } from "util";
const dashboardService = new DashboardService();
import { SummaryServices } from "../src/services/summaryService";
import { AESService } from "../src/services/AES.js";
let aesService = new AESService()
const SummaryService = new SummaryServices();

import helpLinks from "../src/widgets/HelpLinks";
import supportformmodal from "../src/widgets/SupportFormModal";
const default_layout = "no-sidebar";

export default {
  name: "app",
  components: {
    appChat: ChatVue,
    helpLinks,
    "supportformmodal": supportformmodal,
  },
  data() {
    return {
      // countDown: 54000,
      idleVue_onIdle: "",
      pageName: ""
    };
  },
  watch: {
    $route() {
      this.pageName = this.$route.name.trim().toLowerCase();
      console.log(this.pageName);
    }
  },
  created() {
    this.$forceUpdate();
    // window.console = console;
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });
    // this.countDownTimer();
    // if (sessionStorage.getItem("sessiontimeout")) {
    //   var token = JSON.parse(sessionStorage.getItem("sessiontimeout"));
    //   console.log(token);
    //   var userId = token.userid;
    //   var auditNo = token.usercode;
    //   var myVar = setInterval(function() {
    //     if (!sessionStorage.getItem("sessiontimeout")) {
    //       clearInterval(myVar);
    //     } else {
    //       SummaryService.getExtendSession(auditNo, userId).then(res => {
    //         console.log("res", res);
    //       });
    //     }
    //   }, 1080000);
    // }
  },

  onActive() {
    console.log("I am Active");
  },
  onIdle() {
    this.onidle()
  },
  computed: {
    layout() {
      return ((this.$route && this.$route.meta && this.$route.meta.layout) || default_layout) + "-layout";
    }
  },
  methods: {
    // countDownTimer() {
    //   if (this.countDown > 0) {
    //     setTimeout(() => {
    //       this.countDown -= 1;
    //       this.countDownTimer();
    //     }, 1000);
    //     console.log(this.countDown);
    //   }
    // }
    onidle() {
    console.log("I am INactive");
    if (sessionStorage.getItem("token")) {
      var auditNumber = sessionStorage.getItem("AuditNumber");
      if (
        this.$route.name == "PartnerApproval" ||
        this.$route.name == "Summary"
      ) {
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
      } else {
        let data = {};
        var logouttime = new Date();
        data.lastActionTime = null;
        data.loginAuditNumber = aesService.EncodeUsingAES(auditNumber);
        data.logoutTime = logouttime;
        data.logoutType = "U";
        dashboardService
          .userLogout(data)
          .then(res => {
            sessionStorage.clear();
            // location.reload();
            // this.$router.push("/login");
            this.$router.push({
              name: "Login",
              params: {
                sourceFrom: "ShowValidationMessage"
              }
            });
          })
          .catch(err => {});
      }
    }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600");
@import url("https://fonts.googleapis.com/css?family=Exo:400,700");
@import url("https://fonts.googleapis.com/css?family=Lato");
@import url("https://fonts.googleapis.com/css?family=Titillium+Web&display=swap");
@import url("https://fonts.googleapis.com/css?family=Titillium+Web&display=swap");
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap");
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css");


html,
body {
  scroll-behavior: smooth;
}

#app {
  scroll-behavior: smooth;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/* Calender icon height */
.table td {
  font-family: "Source Sans Pro", sans-serif !important;
}
.mx-input-append {
  height: 30px !important;
}

/* Hide HTML5 Up and Down arrows. */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
.source-sans-pro {
  font-family: "Source Sans Pro", sans-serif;
}

.terms-modal > #terms___BV_modal_outer_ > .modal.show .modal-dialog {
  max-width: 80% !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
/* .primary {
  background-color: #00000000 !important ;
  border-color: #00000000 !important ;
} */
/* Popover Properties */
.popover {
  background-color: #f8f8f8;
  max-width: 100% !important;
}

/* Popover Properties ends */
/* OpenSans Font */
.openSans-regular {
  font-family: "Open Sans", sans-serif;
  font-weight: normal;
}
.openSans-semiBold {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
}

/* Exo Font */
.exo-regular {
  font-family: "Exo", sans-serif;
  font-weight: normal;
}
.exo-regular-input {
  font-family: "Exo", sans-serif;
  font-weight: normal;
  font-size: 32px !important;
}
.exo-bold {
  font-family: "Exo", sans-serif;
  font-weight: bold;
}
.exo-regular-input {
  font-family: "Exo", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.2px;
  text-align: left;
  color: #484848;
}

/* Lato Font */
.lato-regular {
  font-family: "Lato", sans-serif;
  font-weight: normal;
}
/* .lato-regular-input {
  font-family: "Lato", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.2px;
  text-align: left;
  color: #484848;
} */

/* Titillium Font */
.titillium-regular {
  font-family: "Titillium Web", sans-serif;
  font-weight: normal;
}

/* General */
.no-weight {
  font-weight: normal !important;
}

/* Stepper */
.theme--light.v-stepper {
  box-shadow: none;
}
.home-button {
  background-color: #ffffff !important;
  box-shadow: none !important;
  border: solid 1px #002d72;
  font-size: 20px !important;
  font-weight: normal;
  line-height: 1.35;
  height: 64px;
  letter-spacing: 0.8px;
  color: #002d72 !important;
}
.continue-button {
  border: solid 1px #002d72;
  background-color: #002d72 !important;
  font-size: 24px !important;
  line-height: 1.38;
  letter-spacing: 1px;
  height: 64px;
  color: #ffffff !important;
  box-shadow: none !important;
}

.loginParent > .width-control-small {
  width: 100% !important;
}

/* MultiSelect Style */
.select .checkboxLayer {
  height: auto;
  overflow: auto;
}
.margin-left-20 {
  margin-right: 50px !important;
}
/* .margin-right-10 {
  float: left !important;
  padding-left: 10px;
  background-color: yellow;
} */
.select > .historyButton > .right {
  float: left !important;
}

.col-form-label {
  font-family: "Exo", sans-serif;
  font-weight: normal;
  margin: auto !important;
}

/* Vuetify Carousel */
.v-window__container {
  height: 100%;
}
.v-responsive {
  height: 100% !important;
}
.v-carousel__controls {
  background: #00000000 !important;
}

input[type="number"] {
  width: 100%;
}

.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  outline: none !important;
  border: none !important;
}

textarea:focus,
input[type="text"]:focus,
input[type="password"]:focus,
input[type="datetime"]:focus,
input[type="datetime-local"]:focus,
input[type="date"]:focus,
input[type="month"]:focus,
input[type="time"]:focus,
input[type="week"]:focus,
input[type="number"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="tel"]:focus,
input[type="color"]:focus,
.uneditable-input:focus {
  box-shadow: none;
  outline: 0 none;
  border: 1px solid #c4c4c4 !important;
}

input[type="search"]:focus {
  box-shadow: none;
  outline: 0 none;
  border: none !important;
}

.bold > legend {
  font-weight: bold !important;
}

select:focus {
  box-shadow: none !important;
  outline: 0 none !important;
  border: 1px solid #c4c4c4 !important;
}

/* Scroll - bar  */
/* width */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #d8d8d8;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0071bc;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #0071bc90;
}

/* Progress Bar */
.progress-bar {
  background-color: #0156b1 !important;
}

/* Multi Select */
.select {
  width: 100%;
}
.select:disabled {
  background-color: #e9ecef;
}
.select > button {
  width: 100%;
  font-family: "Lato", sans-serif;
  font-weight: normal;
  text-align: left !important;
}
.select > button:disabled {
  background-color: #e9ecef !important;
}
.select .buttonLabel {
  text-align: left !important;
}
/* Accordion Expansion */
.v-expansion-panel__header {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.04;
  letter-spacing: 0.2px;
  text-align: left;
  color: #272727;
  width: 100%;
}
.v-expansion-panel {
  width: 90% !important;
  margin: auto !important;
}
.v-expansion-panel {
  border: solid 1px #bababa;
  box-shadow: none !important;
}
@media (max-width: 1300px) {
  .field-headings {
    font-size: 12px;
  }
}
@media (max-width: 1150px) {
  .field-headings {
    font-size: 10.2px;
  }
}
@media (max-width: 1060px) {
  .table_header {
    font-size: 13px !important;
  }
}
/* .modal-dialog {
  max-width: 650px !important;
} */

/* 
.v-ripple__container{
  background-color: orange;
} */
/* Checkbox */
/* .custom-control-label::before {
  margin-top: 0.17rem !important;
} */
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #002d72 !important;
  background-color: #002d72 !important;
  /* margin-top: 0.17rem !important;
  left: -1.6rem !important; */
}
/* .custom-control-label::after {
  top: 3px !important;
  left: -41px !important;
  width: 53px !important;
  height: 17px !important;
} */
.v-stepper--alt-labels .v-stepper__step {
  padding-bottom: 0px !important;
}
.v-expansion-panel {
  user-select: none;
}
.cardDetails {
  user-select: none;
  cursor: pointer;
}
.card-img {
  user-select: none;
  cursor: pointer;
}
.spinner-wrapper {
  z-index: 10000000 !important;
  background: rgba(0, 0, 0, 0.5);
}
.dashboard-main-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  color: #272727;
  width: 100%;
}
</style>

